import { Component } from "@angular/core";
import { ENVIRONMENT } from "../../../environments/environment";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.less"],
})
export class FooterComponent {
  public domainName: string = ENVIRONMENT.SOCIALS.SLOGAN;
  public privacyURL: string = ENVIRONMENT.SOCIALS.LINKS.PRIVACY;
  public disclaimerURL: string = ENVIRONMENT.SOCIALS.LINKS.DISCLAIMER;
}
